import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FOLDER_PATH_HEADER_NAME } from '@pages/monitoring/monitoring.interceptor';

export interface IDismissResponse {
    success: boolean;
    message: string;
    failedItems: number[];
}

@Injectable({
    providedIn: 'root',
})
export class ErrorMonitoringService {
    constructor(
        private _http: HttpClient,
    ) { }

    public dismiss(entityIds: number[], fqn?: string) {
        const endpoint = `/monitoring/ErrorLogsMonitoring/DismissErrorsBulk`;

        return this._http.post<IDismissResponse>(endpoint, entityIds,
            fqn
                ? { headers: { [FOLDER_PATH_HEADER_NAME]: fqn } }
                : undefined,
        );
    }
}
